import { FLAT_ORG, MANAGER_TRAINING_ORG } from "../run/orgIds.js";
import type { CardInstance, CardLookup, OrganizationId } from "../types/index.js";

export type WorkerProgressInput = {
  hand: readonly CardInstance[];
  organizations: readonly OrganizationId[];
  lookup: CardLookup;
  noActionsPlayed?: boolean;
};

const STARTER_WORKERS = new Set(["intern", "idle"]);

function workerGain(
  cardId: string,
  progress: number,
  organizations: readonly OrganizationId[],
  noActionsPlayed: boolean,
): number {
  let gain = progress;
  if (organizations.includes(MANAGER_TRAINING_ORG) && !STARTER_WORKERS.has(cardId)) {
    gain += 1;
  }
  if (organizations.includes(FLAT_ORG) && noActionsPlayed) {
    gain += 1;
  }
  return gain;
}

export function workerProgress(input: WorkerProgressInput): number {
  const noActions = input.noActionsPlayed === true;
  let sum = 0;

  for (const card of input.hand) {
    const definition = input.lookup(card.cardId);
    if (definition?.type === "worker" && definition.progress !== undefined) {
      sum += workerGain(card.cardId, definition.progress, input.organizations, noActions);
    }
  }

  return sum;
}
